<rt-trip-details
    [tripId]="ormId$ | async"
    [tripRefFieldDefs]="tripRefFieldDefs$ | async"
></rt-trip-details>
